import React from "react";

const Spinner = (props) => {
  return (
    <div className={props.classes + " mx-auto d-block "}>
      <span></span>
    </div>
  );
};

export default Spinner;
